import React, { Component } from 'react'
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl'
import FromEmailSelect from "./fromemailselection.component.jsx";


const messages = defineMessages({
    "displayed_email_type_placeholder": {
        id: 'document.info.content.input.email_select_placeholder',
        defaultMessage: 'Choose from one of the options provided',
    },
    "chatFloatingButtonLabel": {
        id: 'question.conversation.ask_a_question',
        defaultMessage: "Ask a question",
    },
})


class DocumentInfoContentInput extends Component {

    constructor(props, context) {
        super(props, context)
        const content = this.props.value || {}
        this.state = {
            className: this.props.className || '',
            onChange: this.props.onChange || function () {
            },
            showParentOrganization: content.showParentOrganization || false,
            showContactTaxNumber: content.showContactTaxNumber || false,
            showAccountTaxNumber: content.showAccountTaxNumber || false,
            showShippingContact: content.showShippingContact || false,
            onlyShowOrganization: content.onlyShowOrganization || false,
            showSellerCompanyName: content.showSellerCompanyName || false,
            showCustomerCompanyName: content.showCustomerCompanyName || false,
            hideSellerName: content.hideSellerName || false,
            hideCustomerEmail: content.hideCustomerEmail || false,
            hideDueDate: content.hideDueDate || false,
            hideExpirationDate: content.hideExpirationDate || false,
            disableChat: content.disableChat || false,
            displayedEmailType: content.displayedEmailType || '',
            hideSection: content.hideSection || false,
            chatFloatingButtonLabel: content.chatFloatingButtonLabel || this.props.intl.formatMessage(messages["chatFloatingButtonLabel"]),
            hideOrderReference: content.hideOrderReference || false,
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleFromEmailChange = this.handleFromEmailChange.bind(this)
    }

    triggerChanged() {
        this.state.onChange({
            showParentOrganization: this.state.showParentOrganization,
            showContactTaxNumber: this.state.showContactTaxNumber,
            showAccountTaxNumber: this.state.showAccountTaxNumber,
            showShippingContact: this.state.showShippingContact,
            onlyShowOrganization: this.state.onlyShowOrganization,
            showSellerCompanyName: this.state.showSellerCompanyName,
            showCustomerCompanyName: this.state.showCustomerCompanyName,
            hideSellerName: this.state.hideSellerName,
            hideCustomerEmail: this.state.hideCustomerEmail,
            hideDueDate: this.state.hideDueDate,
            hideExpirationDate: this.state.hideExpirationDate,
            disableChat: this.state.disableChat,
            displayedEmailType: this.state.displayedEmailType,
            hideSection: this.state.hideSection,
            chatFloatingButtonLabel: this.state.chatFloatingButtonLabel,
            hideOrderReference: this.state.hideOrderReference,
        })
    }

    componentDidMount() {
        this.triggerChanged()
    }

    componentWillReceiveProps(nextProps) {
        const content = nextProps.value || {}
        this.setState({
            showParentOrganization: content.showParentOrganization || false,
            showShippingContact: content.showShippingContact || false,
            showContactTaxNumber: content.showContactTaxNumber || false,
            showAccountTaxNumber: content.showAccountTaxNumber || false,
            onlyShowOrganization: content.onlyShowOrganization || false,
            showSellerCompanyName: content.showSellerCompanyName || false,
            showCustomerCompanyName: content.showCustomerCompanyName || false,
            hideSellerName: content.hideSellerName || false,
            hideCustomerEmail: content.hideCustomerEmail || false,
            hideDueDate: content.hideDueDate || false,
            hideExpirationDate: content.hideExpirationDate || false,
            disableChat: content.disableChat || false,
            displayedEmailType: content.displayedEmailType || '',
            hideSection: content.hideSection || false,
            chatFloatingButtonLabel: content.chatFloatingButtonLabel || this.props.intl.formatMessage(messages["chatFloatingButtonLabel"]),
            hideOrderReference: content.hideOrderReference || false,
        })
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        }, this.triggerChanged)
    }

    handleFromEmailChange(emailType) {
        this.setState({
            displayedEmailType: emailType
        }, this.triggerChanged)
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-2" />
                    <div className="col-12">

                        <div className="custom-control custom-checkbox mb-2">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hideSection"
                                name="hideSection"
                                value={this.state.hideSection}
                                checked={this.state.hideSection}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="hideSection">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.pricing_table.hide_section"
                                    defaultMessage="Hide contact information"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_section"
                                    defaultMessage="This will hide the entire contact information section"
                                />
                            </small>
                        </div>

                        <div className="mb-2">
                            <label className="mb-0" htmlFor="displayedEmailType">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.displayed_email_type_label"
                                    defaultMessage="Email address"
                                />
                            </label>
                            <FromEmailSelect
                                placeholder={this.props.intl.formatMessage(messages["displayed_email_type_placeholder"])}
                                value={this.state.displayedEmailType}
                                onChange={this.handleFromEmailChange}
                            />
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.displayed_email_type_description"
                                    defaultMessage="Email address to be displayed on the documents"
                                />
                            </small>
                        </div>

                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="showParentOrganization"
                                name="showParentOrganization"
                                value={this.state.showParentOrganization}
                                checked={this.state.showParentOrganization}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="showParentOrganization">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.show_parent_organization_label"
                                    defaultMessage="Show company name when the recipient is a person"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.show_parent_organization_description"
                                    defaultMessage="This will show company name in addition to the person's name when the selected customer is a person."
                                />
                            </small>
                        </div>

                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="showContactTaxNumber"
                                name="showContactTaxNumber"
                                value={this.state.showContactTaxNumber}
                                checked={this.state.showContactTaxNumber}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="showContactTaxNumber">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_contact_tax_number_label"
                                    defaultMessage="Hide contact Tax number"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_Contact_tax_number_description"
                                    defaultMessage="This will hide the contact's Tax number."
                                />
                            </small>
                        </div>

                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="showAccountTaxNumber"
                                name="showAccountTaxNumber"
                                value={this.state.showAccountTaxNumber}
                                checked={this.state.showAccountTaxNumber}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="showAccountTaxNumber">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_account_tax_number_label"
                                    defaultMessage="Hide your company's Tax number"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_account_tax_number_description"
                                    defaultMessage="This will hide your company's Tax number."
                                />
                            </small>
                        </div>

                        {this.props.variables.document.type === 'invoice' && this.props.variables.quote.orderReferenceIdentifier &&
                            < div className="custom-control custom-checkbox">
                                <input
                                    className="custom-control-input"
                                    type="checkbox"
                                    id="hideOrderReference"
                                    name="hideOrderReference"
                                    value={this.state.hideOrderReference}
                                    checked={this.state.hideOrderReference}
                                    onChange={this.handleFormChange}
                                />
                                <label className="custom-control-label" htmlFor="hideOrderReference">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.hide_order_reference"
                                        defaultMessage="Hide order reference"
                                    />
                                </label>
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.hide_order_reference_descriptions"
                                        defaultMessage="This will hide the order reference number linked to the invoice"
                                    />
                                </small>
                            </div>
                        }

                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="onlyShowOrganization"
                                name="onlyShowOrganization"
                                value={this.state.onlyShowOrganization}
                                checked={this.state.onlyShowOrganization}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="onlyShowOrganization">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.only_show_organization_label"
                                    defaultMessage="Only show the company name"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.nly_show_organization_description"
                                    defaultMessage="This will show only company name when the selected customer is a person."
                                />
                            </small>
                        </div>

                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="showShippingContact"
                                name="showShippingContact"
                                value={this.state.showShippingContact}
                                checked={this.state.showShippingContact}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="showShippingContact">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.show_shipping_contact_label"
                                    defaultMessage="Show shipping contact and address"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table..show_shipping_contact_description"
                                    defaultMessage="This will show the shipping contact information."
                                />
                            </small>
                        </div>

                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="showSellerCompanyName"
                                name="showSellerCompanyName"
                                value={this.state.showSellerCompanyName}
                                checked={this.state.showSellerCompanyName}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="showSellerCompanyName">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.show_seller_company_name_label"
                                    defaultMessage="Show your company name"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.show_seller_company_name_description"
                                    defaultMessage="This will show your company name in the 'From' section."
                                />
                            </small>
                        </div>

                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="showCustomerCompanyName"
                                name="showCustomerCompanyName"
                                value={this.state.showCustomerCompanyName}
                                checked={this.state.showCustomerCompanyName}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="showCustomerCompanyName">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.show_customer_company_name_label"
                                    defaultMessage="Show customer's company name"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.show_customer_company_name_description"
                                    defaultMessage="This will show your customer's company name in the 'To' section when the selected customer is a company."
                                />
                            </small>
                        </div>

                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hideSellerName"
                                name="hideSellerName"
                                value={this.state.hideSellerName}
                                checked={this.state.hideSellerName}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="hideSellerName">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_seller_name_label"
                                    defaultMessage="Hide seller name"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_seller_name_description"
                                    defaultMessage="This will hide the seller name in the 'From' section."
                                />
                            </small>
                        </div>

                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hideCustomerEmail"
                                name="hideCustomerEmail"
                                value={this.state.hideCustomerEmail}
                                checked={this.state.hideCustomerEmail}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="hideCustomerEmail">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_customer_email_label"
                                    defaultMessage="Hide customer's email"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_customer_email_description"
                                    defaultMessage="This will hide the customer's email in the 'To' section."
                                />
                            </small>
                        </div>

                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hideExpirationDate"
                                name="hideExpirationDate"
                                value={this.state.hideExpirationDate}
                                checked={this.state.hideExpirationDate}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="hideExpirationDate">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.expiration_date_label"
                                    defaultMessage="Hide expiration date"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.expiration_date_description"
                                    defaultMessage="This will hide the expiration date of the proposal."
                                />
                            </small>
                        </div>

                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hideDueDate"
                                name="hideDueDate"
                                value={this.state.hideDueDate}
                                checked={this.state.hideDueDate}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="hideDueDate">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_due_date_label"
                                    defaultMessage="Hide due date"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_due_date_description"
                                    defaultMessage="This will hide the due date."
                                />
                            </small>
                        </div>

                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="disableChat"
                                name="disableChat"
                                value={this.state.disableChat}
                                checked={this.state.disableChat}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="disableChat">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.disable_chat_label"
                                    defaultMessage="Disable chat"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.disable_chat_description"
                                    defaultMessage="This will disable the chat. Customers won't be able to ask you questions directly from the proposal"
                                />
                            </small>
                        </div>
                        {
                            !this.state.disableChat &&
                            <div className="mb-2 mt-2">
                                <label className="mb-0" htmlFor="displayedEmailType">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.approve_section.chat_floating_button_label"
                                        defaultMessage="Chat floating button label"
                                    />
                                </label>
                                <input
                                    name="chatFloatingButtonLabel"
                                    value={this.state.chatFloatingButtonLabel}
                                    onChange={this.handleFormChange}
                                    id="chatFloatingButtonLabel"
                                    type="text"
                                    className="form-control"
                                />
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.approve_section.chat_floating_button_description"
                                        defaultMessage="The label to display on the chat floating button"
                                    />
                                </small>
                            </div>
                        }

                    </div>
                </div>
            </div >
        );
    }
}

export default injectIntl(DocumentInfoContentInput)


// WEBPACK FOOTER //
// ./src/template/sections/content/document-info/input.component.jsx